export default ({ detailsState }) => {
    return detailsState.response && detailsState.response.headers;
};
